export enum DMN_IND_FLUXO_RECAD {
  ATIVO = "ATI",
  ASSISTIDO = "ASS",
  SALDADOS = "SLD"
}